import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const mmtc_buy_responseApi = createAsyncThunk("mmtc_buy_response", async ({ startDate = null, endDate = null }) => {
  const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
  const response = await axiosInstance.get("/mmtc_buy_response",{ params });
  return response.data;
});

const mmtc_buy_responseSlice = createSlice({
  name: "mmtc_buy_response",
  initialState: {
    mmtc_buy_response: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(mmtc_buy_responseApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(mmtc_buy_responseApi.fulfilled, (state, action) => {
        state.mmtc_buy_response = action.payload;
        state.loading = false;
      })
      .addCase(mmtc_buy_responseApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default mmtc_buy_responseSlice.reducer;
